import { New, Title, NewDate, Content, NewsRepository } from '@/Domain/News'
import { LanguageCode } from '@/Domain/Localization'

const createNews = () => {
  return (
    [
      new New(
        new Title('Titulo nova 1'),
        new NewDate('01/06/2020'),
        new Content('%3Cp%3EUn%20contido%20HTML%3C%2Fp%3E%3Cp%3ECodificado%20con%20url_encode%3C%2Fp%3E')
      ),
      new New(
        new Title('Titulo nova 2'),
        new NewDate('02/06/2020'),
        new Content('%3Cp%3EUn%20contido%20HTML%3C%2Fp%3E%3Cp%3ECodificado%20con%20url_encode%3C%2Fp%3E')
      )
    ]
  )
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryNewsRepository implements NewsRepository {
  // eslint-disable-next-line
  async fetchAll (languageCode: LanguageCode): Promise<New[]> {
    const duration = 300
    await wait(duration)
    const reviews = createNews()
    return reviews
  }
}
